import * as React from 'react';

import { AmenityBody } from 'components/infosite/amenities/internals/amenity-body';

export interface RenderAmenityHelperProps {
  text: string;
  index: number;
  category: string;
}

export const RenderAmenityBody = ({ text, index, category }: RenderAmenityHelperProps) => {
  if (!text || (text && text.length === 0)) {
    return null;
  }

  return <AmenityBody key={`${category}-${index}`} text={text} index={index} category={category} />;
};
